<template>
  <div>
    <van-cell title-style="text-align:left;" is-link @click="show=true">
      <template #title>
        <span class="custom-title">{{ title}}</span>
      </template>
    </van-cell>
    <van-action-sheet v-model="show" :title="'请选择' + fullName(this.item.level)" :actions="item.subList" @select="onSelect" />
  </div>
</template>

<script>
import { Cell, CellGroup, ActionSheet, Toast } from "vant";

export default {
  name: "CarChooseDownList",
  props: ["item"],
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [ActionSheet.name]: ActionSheet,
    [Toast.name]: Toast,
  },
  data() {
    return {
      show: false,
      title: "请选择" + this.fullName(this.item.level),
    };
  },
  methods: {
    fullName(level) {
      let name = "";
      switch (level) {
        case 1:
          name = "车系";
          break;
        case 2:
          name = "品牌";
          break;
        case 3:
          name = "车型";
          break;
        case 4:
          name = "年份";
          break;
        case 5:
          name = "排气量或电动";
          break;
        case 6:
          name = "发动机";
          break;
      }
      return name;
    },
    onSelect(node) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false;
      this.title = node.name;
      this.$emit("call-func", [node.id, this.item.id, this.item]);
    },
  },
};
</script>